<script>
    import { onMount } from "svelte";
    import { t, locale } from "$lib/translations";
    import { selectStep } from "/src/store";
    import Step from "../../../components/ui/Step.svelte";
    import Modal from "/src/components/ui/Modal.svelte";

    import Pers_0 from "$lib/images/pers0.webp";
    import Pers_1 from "$lib/images/pers1.webp";
    import Pers_2 from "$lib/images/pers2.webp";
    import Discord from "$lib/images/discord.webp";
    import Pers_3 from "$lib/images/pers3.webp";

    let steps = [];

    $: {
        steps = [
            {
                id: 1,
                image: Pers_1,
                step: $t("how_to_play.step_one_title"),
                stepName: $t("how_to_play.step_one"),
                description: $t("how_to_play.step_one_description"),
                buttons: [
                    $t("how_to_play.step_one_button_one"),
                    $t("how_to_play.step_one_button_two"),
                    $t("how_to_play.step_one_button_three"),
                ],
                modalInfo: {
                    title: $t("how_to_play.modal_one_title"),
                    description: $t("how_to_play.modal_one_description"),
                },
            },
            {
                id: 2,
                image: Pers_2,
                step: $t("how_to_play.step_two_title"),
                stepName: $t("how_to_play.step_two"),
                description: $t("how_to_play.step_two_description"),
                buttons: [
                    $t("how_to_play.step_two_button_one"),
                    $t("how_to_play.step_two_button_two"),
                    $t("how_to_play.step_two_button_three"),
                ],
                modalInfo: {
                    title: $t("how_to_play.modal_two_title"),
                    description: $t("how_to_play.modal_two_description"),
                },
            },
            {
                id: 3,
                image: Discord,
                step: $t("how_to_play.step_three_title"),
                stepName: $t("how_to_play.step_three"),
                description: $t("how_to_play.step_three_description"),
                buttons: [$t("how_to_play.step_three_button_one"), $t("how_to_play.step_three_button_two")],
            },
            {
                id: 4,
                image: Pers_3,
                step: $t("how_to_play.step_four_title"),
                stepName: $t("how_to_play.step_four"),
                description: $t("how_to_play.step_four_description"),
                ip: $t("how_to_play.step_four_ip"),
                buttons: [],
            },
        ];

        steps = $locale === "ua" ? [{ id: 0, image: Pers_0, form: true, buttons: [] }, ...steps] : [...steps];
    }

    let currentStep = 0;
    let isModalOpen = false;
    let modalData = {};
    let fadeFlyIn = false;
    let fadeFlyOut = false;

    function openModal() {
        modalData = steps[currentStep].modalInfo;
        isModalOpen = true;

        fadeFlyIn = true;

        setTimeout(() => {
            fadeFlyIn = false;
        }, 500);
    }

    function closeModal() {
        fadeFlyOut = true;

        setTimeout(() => {
            fadeFlyOut = false;
            isModalOpen = false;
        }, 500);
    }

    function nextStep() {
        if (currentStep < steps.length - 1) {
            currentStep += 1;

            // if (currentStep === 1) {
            //     window.dataLayer = window.dataLayer || [];
            //     dataLayer.push({
            //         'event': "step_1_succes"
            //     });
            if (currentStep === 1) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: "step_2_succes",
                });
            } else if (currentStep === 2) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: "step_3_succes",
                });
            } else if (currentStep === 3) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: "step_4_succes",
                });
            } else if (currentStep === 4) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: "step_5_succes",
                });
            }
        }
    }

    function prevStep() {
        if (currentStep > 0) {
            currentStep -= 1;
        }
    }

    onMount(() => {
        selectStep.set("register");
    });
</script>

<svelte:head>
    <title>{$t("how_to_play.link_title")}</title>
    <meta name="description" content={$t("how_to_play.link_description")} />
</svelte:head>

<Step stepData={steps[currentStep]} {currentStep} {openModal} {prevStep} {nextStep} />

{#if isModalOpen}
    <div class="anim-wrapper" class:fade-in={fadeFlyIn} class:fade-out={fadeFlyOut}>
        <Modal {modalData} {closeModal} />
    </div>
{/if}

<style lang="scss">
    @keyframes fadeFlyIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes fadeFlyOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    .anim-wrapper {
        will-change: opacity;

        &.fade-in {
            animation: fadeFlyIn 500ms forwards;
        }

        &.fade-out {
            animation: fadeFlyOut 500ms forwards;
        }
    }
</style>
